// extracted by mini-css-extract-plugin
export default {"ContentDefinitionListContainer":"ContentDefinitionList_ContentDefinitionListContainer__CT2QS"};